import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=52fa42fa"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"
import style0 from "./additional.vue?vue&type=style&index=0&id=52fa42fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports